import store from '@/store/store'

export const calcAverages = (series) => {
  if (!series.length) return []
  const totals = series.reduce((a, series) => (a = !a ? series : a.map((val, i) => val + series[i])), null)
  return totals.map(val => val / series.length)
}

export const calcFilteredAverages = (series) => {
  const averages = calcAverages(series)
  return store.getters['gameplay/emotionsToDisplay'].map(i => averages[i])
}
